import '../App.css';
import { Link } from 'react-router-dom';
import Layout from "../components/Layout";

const DRILLS = [
  { label: "Addition", glyph: "+", variant: "op-add" },
  { label: "Subtraction", glyph: "−", variant: "op-sub" },
  { label: "Multiplication", glyph: "×", variant: "op-mul" },
  { label: "Division", glyph: "÷", variant: "op-div" },
];

function Practice() {
  return (
    <Layout>
      <h1 className="section-title">Practice Grove</h1>
      <p className="tagline">No timer, no pressure — just you and the numbers.</p>

      <div className="op-grid">
        {DRILLS.map(({ label, glyph, variant }) => (
          <div key={label} className={`op-card is-static ${variant}`}>
            <span className="badge badge-coral coming-soon">Soon</span>
            <span className="op-glyph">{glyph}</span>
            <span className="op-label">{label}</span>
          </div>
        ))}
      </div>

      <div className="leaf-divider">🌿 🍌 🌿</div>

      <div className="btn-row">
        <Link className="btn" to="/play">Play Timed Instead</Link>
        <Link className="btn btn-leaf" to="/">Back to the Treehouse</Link>
      </div>
    </Layout>
  );
}

export default Practice;
